import React, { Component } from 'react';
import ReportExplainer from '../index';
import { withTranslation } from 'react-i18next';

class ReportExplainerContentGaps extends Component {
    constructor() {
        super();

        this.state = {
            showMore: false,
        };
    }

    render() {
        const { t } = this.props;

        const text = (
            <div className="report-explainer-custom">
                <div>{t('commerce.detail.content_gaps.report_explainer.text1')}</div>
                <div className={!this.state.showMore ? 'with-show-more' : ''}>
                    <ol>
                        <li>{t('commerce.detail.content_gaps.report_explainer.text2')}</li>
                        <li>{t('commerce.detail.content_gaps.report_explainer.text3')}</li>
                        <li>{t('commerce.detail.content_gaps.report_explainer.text4')}</li>
                        <li>{t('commerce.detail.content_gaps.report_explainer.text5')}</li>
                    </ol>
                </div>
                {this.state.showMore ? (
                    <>
                        <div>
                            <strong>
                                {t('commerce.detail.content_gaps.report_explainer.text6')}
                            </strong>
                        </div>
                        <div>
                            <ul>
                                <li>{t('commerce.detail.content_gaps.report_explainer.text7')}</li>
                                <li>{t('commerce.detail.content_gaps.report_explainer.text8')}</li>
                                <li>{t('commerce.detail.content_gaps.report_explainer.tex9')}</li>
                                <li>{t('commerce.detail.content_gaps.report_explainer.text10')}</li>
                                <li>{t('commerce.detail.content_gaps.report_explainer.text11')}</li>
                                <li>{t('commerce.detail.content_gaps.report_explainer.text12')}</li>
                                <li>{t('commerce.detail.content_gaps.report_explainer.text13')}</li>
                            </ul>
                        </div>
                        <div>
                            <strong>
                                {t('commerce.detail.content_gaps.report_explainer.text14')}
                            </strong>
                        </div>
                        <div>
                            <ul>
                                <li>{t('commerce.detail.content_gaps.report_explainer.text15')}</li>
                                <li>{t('commerce.detail.content_gaps.report_explainer.text16')}</li>
                                <li>{t('commerce.detail.content_gaps.report_explainer.text17')}</li>
                                <li>{t('commerce.detail.content_gaps.report_explainer.text18')}</li>
                            </ul>
                        </div>
                        <div className="show-more-btn">
                            <button onClick={() => this.setState({ showMore: false })}>
                                <i className="icon-arrow-up" />
                                {t('commerce.detail.content_gaps.report_explainer.show_less')}
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="show-more-btn absolute-btn">
                        <button onClick={() => this.setState({ showMore: true })}>
                            <i className="icon-arrow-down" />
                            {t('commerce.detail.content_gaps.report_explainer.show_more')}
                        </button>
                    </div>
                )}
            </div>
        );
        return (
            <ReportExplainer
                isNotText
                textcontent={text}
                descriptionHidden={false}
                title={t('commerce.detail.content_gaps.report_explainer.title')}
            />
        );
    }
}

export default withTranslation()(ReportExplainerContentGaps);
